import React from "react";
import * as Styled from "./Style";
import closeIcon from "./../../assets/images/icons/ic_close.svg";

const Modal = (props) => {
  return (
    <Styled.ModalStyle className={props.show + " " + props.classes}>
      <div className="modal-bg" onClick={props.close}></div>
      <div className="modal-content">
        <div className="modal-header">
          <Styled.ModalCloseStyle
            type="button"
            title="Close modal"
            onClick={props.close}
            // tabIndex={props.tabIdx}
          >
            <img src={`${closeIcon}`} alt="" />
          </Styled.ModalCloseStyle>
        </div>
        <div className="modal-body">{props.children}</div>
      </div>
    </Styled.ModalStyle>
  );
};

export default Modal;
